<template>
    <div></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      code: null
    }
  },
  computed: {
    ...mapGetters([
      'authenticated'
    ])
  },
  created: async function () {
    this.code = this.$route.query.code
    if (this.authenticated) {
      this.$router.push('/')
    } else if (this.code) {
      await this.$store.dispatch('GET_TOKENS', this.code)
      this.$router.push('/')
    } else {
      window.location = process.env.AUTH_ENDPOINT + '/login?' +
        'response_type=code&client_id=' + process.env.COGNITO_APP_CLIENT_ID +
        '&redirect_uri=' + process.env.PORTAL_ENDPOINT + '/login'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue